import { useEffect, useState } from 'react';

/**
 * SSR-safe landscape detection. Returns `false` on the server (and on the first
 * client render, to avoid a hydration mismatch), then corrects in an effect.
 */
export function useOrientation(): boolean {
  const [landscape, setLandscape] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(orientation: landscape)');
    const onChange = (): void => {
      setLandscape(mq.matches);
    };
    onChange();
    mq.addEventListener('change', onChange);
    return () => {
      mq.removeEventListener('change', onChange);
    };
  }, []);

  return landscape;
}
